<template>
    <div>
      <div class="title">
        <span>成员介绍</span>
      </div>
      <div style="margin-top: 20px" class="between">
        <div class="namePath">
          <el-image
            style="width: 150px; height: 200px"
            fit="cover"
            :src="detail.headImage"
          ></el-image>
          <div class="text">
            <div>
                <h1>{{ detail.name }}</h1>
                <h2>{{ detail.englishName }}</h2>
            </div>
            <p class="ql-editor" v-html="detail.officeAddress"></p>
            <!-- <p>其他补充简介 </p> -->
          </div>
        </div>
        <div class="inner right">
          <div v-if="detail.tel">电话: {{ detail.tel }}</div>
          <div v-if="detail.email">邮箱: {{ detail.email }}</div>
        </div>
      </div>
      <div class="title" style="margin-top: 20px">
        <span>个人简介</span>
      </div>
      <div class="inner">
        <div class="ql-editor" v-html="detail.description"></div>
      </div>
      <!-- <div v-if="detail.tel || detail.email">
        <div class="title" style="margin-top: 20px">
          <span>联系方式</span>
        </div>
        <div class="inner">
          <div v-if="detail.tel">电话: {{ detail.tel }}</div>
          <div v-if="detail.email">邮箱: {{ detail.email }}</div>
        </div>
      </div> -->
    </div>
  </template>

<script>
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
// import { listGroupMember } from '@/api/api'
export default {
  data () {
    return {
      detail: {}
    }
  },
  created () {
    // listGroupMember().then((res) => {
    //   if (res.data) {
    //     let arr = []
    //     res.data.forEach((element) => {
    //       element.memberList.forEach((i) => {
    //         arr.push(i)
    //       })
    //     })
    //     this.detail = arr.filter((item) => {
    //       // console.log(item)
    //       return item.name === '张坚'
    //     })[0]
    //     if (!this.detail) {
    //       alert('请在后台管理系统添加"张坚"的信息')
    //     }
    //     this.detail.officeAddress = this.detail.officeAddress.replace(
    //       /\n/g,
    //       '<br/>'
    //     )
    //     console.log(this.detail)
    //   }
    // })
    this.detail = JSON.parse(localStorage.memberDetail)
  },
  methods: {
    NToList () {
      // 2
    }
  }
}
</script>

    <style scoped>
  .title {
    letter-spacing: 1px;
    font-size: 28px;
    line-height: 2em;
    color: #2f4f4f;
    border-bottom: 3px solid #2f4f4f;
    font-weight: bold;
  }
  .inner {
    margin-top: 20px;
  }
  .namePath {
    display: flex;
    align-items: center;
    width: 800px;
    /* background: red; */
  }
  .namePath .text {
    margin-left: 20px;
  }
  h1 {
    letter-spacing: 8px;
  }
  .between{
    display: flex;
    justify-content: space-between;
  }
  .right{
    height: 100%;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: end;
    /* flex-grow: 1; */
    width: 280px;
    height: 200px;
    margin-top: 0;
    flex-shrink: 0;
    line-height: 30px;
  }
  .text{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
}
  </style>



// WEBPACK FOOTER //
// src/view/memberDetail.vue